import { createApi } from "@reduxjs/toolkit/dist/query/react"
import {
  RATE_CARDS_CONFIG_ENDPOINT,
  RATE_CARDS_CONFIGS_ENDPOINT,
  RTK_SLICE_API_LIST
} from "../../common/constants"
import { baseQuery, getTags } from "../api"
import { getQueryString } from "../../common/utils"
import { RateCardsConfig, RateCardsConfigDetails } from "../../types"
import bbApi from "../../api"

const reducerPath = "rateCardsConfig"
const rateCardsPath = "rate-cards"

export const rateCardsApi = createApi({
  reducerPath,
  baseQuery,
  tagTypes: [rateCardsPath],
  endpoints: builder => ({
    fetchRateCardsConfigs: builder.query({
      query: (params: { brand_id?: string }) =>
        `${RATE_CARDS_CONFIGS_ENDPOINT}${getQueryString(params)}`,
      transformResponse: (
        responseData:
          | { rate_cards_configs: RateCardsConfig[] }
          | RateCardsConfig[]
      ) => {
        if (Array.isArray(responseData)) {
          return responseData
        }
        return responseData?.rate_cards_configs ?? []
      },
      providesTags: result =>
        Array.isArray(result) ? getTags(rateCardsPath, "id", result) : []
    }),
    fetchRateCardsConfig: builder.query({
      query: (params: { id: string }) =>
        `${RATE_CARDS_CONFIG_ENDPOINT}${getQueryString(params)}`,
      transformResponse: (responseData: RateCardsConfigDetails) => {
        return responseData
      },
      providesTags: (result, error, arg) => [
        { type: rateCardsPath, id: arg.id }
      ]
    }),
    fetchDefaultRateCardsConfig: builder.query({
      query: () => `${RATE_CARDS_CONFIG_ENDPOINT}?id=`,
      transformResponse: (responseData: Record<string, unknown>) => {
        return responseData ?? {}
      }
    }),
    updateOrCreateRateCardsConfig: builder.mutation({
      queryFn: async (payload: Partial<RateCardsConfigDetails>) => {
        if (!payload.id) {
          delete payload.id
        }
        const data = await bbApi.rateCards.updateRateCardsConfig(payload)
        return { data }
      },
      invalidatesTags: (result, error, arg) => {
        const resultData = result as
          | { status?: string; message?: string }
          | undefined
        const isErrorStatus = resultData?.status === "error"
        if (error || isErrorStatus) {
          return []
        }
        return [
          { type: rateCardsPath, id: arg.id },
          { type: rateCardsPath, id: RTK_SLICE_API_LIST }
        ]
      }
    }),
    deleteRateCardsConfig: builder.mutation({
      queryFn: async (id: string) => {
        const data = await bbApi.rateCards.deleteRateCardsConfig(id)
        return { data }
      },
      invalidatesTags: () => [{ type: rateCardsPath, id: RTK_SLICE_API_LIST }]
    })
  })
})

export const {
  useFetchRateCardsConfigsQuery,
  useFetchRateCardsConfigQuery,
  useFetchDefaultRateCardsConfigQuery,
  useUpdateOrCreateRateCardsConfigMutation,
  useDeleteRateCardsConfigMutation
} = rateCardsApi
